import Controller from '../abstracts/Controller';
import 'scss-templates/t-giftCard-check.scss';

export default class GiftcardPageController extends Controller {
    static get COMPONENTS() {
        return [
            'GiftcardFormComponent',
            'GiftcardThumbsComponent',
            'NewsletterPopupComponent',
            'AddToBagBtnComponent',
            'NotifyMeComponent'
        ];
    }
}
